export default __webpack_public_path__ + "static/media/gusd.1048d6d2.svg";